export default defineNuxtPlugin({
  parallel: false,
  setup() {
    return {
      provide: {
        sharedComposable: new WeakMap(),
      },
    }
  },
})
